import React from 'react';
import events from 'lib/events.js';

import Modal from 'components/layout/modal.jsx';
import {FormattedMessage} from 'react-intl';

class ConfirmationModal extends React.Component {
  state = {
    showConfirmationModal: false,
  };

  componentWillMount() {
    this.listener = events.subscribe('season-usage-confirmation-modal', () => {
      this.setState({
        showConfirmationModal: true,
      });
    });
  }

  componentWillUnmount() {
    if (this.listener) {
      this.listener.remove();
    }
  }

  close = () => {
    this.setState({
      showConfirmationModal: false,
    });
  };

  confirm = () => {
    this.props.onConfirm();

    this.setState({
      showConfirmationModal: false,
    });
  };

  render() {
    if (!this.state.showConfirmationModal) {
      return null;
    }

    return <div className='integrations-confirmation-modal'>
      <Modal onClose={this.close} width='100%' hideCloseButton={true}>
        <div className='confirmation-modal container'>
          <div className='row'>
            <div className='col-sm-12'>
              {this.props.children}
              <div className='integration-modal-buttons'>
                <a className='gray-button' onClick={this.close}><FormattedMessage id="general.cancel" /></a>
                <a className='blue-button' onClick={this.confirm.bind(this)}><FormattedMessage id="general.confirm" /></a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>;
  }
}

export default ConfirmationModal;
